<form novalidate>
	<label>
		<input type="checkbox" (change)="showCsvExport = $event.target.checked" />
		{{drivers.length}} drivers.
	</label>

	<div *ngIf="showCsvExport">
		<hr />
		<div>
			<b>Start number</b>,
			<b>Name</b>,
			<b>EPCs</b>,
		</div>
		<div *ngFor="let driver of drivers">
			{{driver.startNumber}},
			{{driver.name}},
			{{driver.epcs.join(', ')}},
		</div>
	</div>
</form>
